import { render } from "./FormatAlignLeft.vue?vue&type=template&id=1806513e"
import script from "./FormatAlignLeft.vue?vue&type=script&lang=js"
export * from "./FormatAlignLeft.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__